import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";

import summaryProgress from "../../images/summary_progress.svg";

/**
 * A reusable visual component that indicates AiMS summarization is currently in progress.
 * This component is purely presentational and does not contain any business logic.
 */
const SummarizingIndicator = () => {
  return (
    <Column alignment="center" width="100%" spacing="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" minWidth="15px"></Box>
        </Theme>
        <Box width="340px">
          <img src={summaryProgress} alt="Summarization in progress" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
        </Box>
      </Row>
      <Column height="16px" spacing="none" />
      <Column spacing="none" spacingInset="none">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" minWidth="68px"></Box>
          </Theme>
          <Text fontFamily="amazonEmber" type="h50" alignment="center">
            Summarizing meeting in progress
          </Text>
        </Row>
      </Column>
    </Column>
  );
};

export default SummarizingIndicator;
